import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=63f276d6&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=63f276d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f276d6",
  null
  
)

export default component.exports